/*
 * @Author: Teemo Ding
 * @Date: 2022-02-18 15:00:35
 * @LastEditTime: 2022-06-06 13:26:14
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/types/common/template.ts
 */

export enum CommunicationCategory {
  OrderStatus = 'OrderStatus',
  PaymentReminder = 'PaymentReminder',
  AbandonedShoppingCart = 'AbandonedShoppingCart',
  RefundStatus = 'RefundStatus',
  ReturnStatus = 'ReturnStatus',
  CreateSubscriptionBuyOrder = 'CreateSubscriptionBuyOrder',
  OrderInvoice = 'OrderInvoice',
  CreateOrder = 'CreateOrder',
  CreateShoppingCart = 'CreateShoppingCart',
  VirtualProductNotification = 'VirtualProductNotification',
  GiftCardIssued = 'GiftCardIssued',
  GiftCardBalanceChanged = 'GiftCardBalanceChanged',
  StoreCreditIssued = 'StoreCreditIssued',
  LogisticsStatusUpdate = 'LogisticsStatusUpdate',
  AccountInvitation = 'AccountInvitation',
  AccountWelcome = 'AccountWelcome',
  AccountPasswordReset = 'AccountPasswordReset',
  VerificationCode = 'VerificationCode',
  CustomerServiceRequest = 'CustomerServiceRequest',
  RestockItem = 'RestockItem',
  FlashSaleStart = 'FlashSaleStart',
  VoucherIssued = 'VoucherIssued',
  VoucherExpiration = 'VoucherExpiration',
}

export enum TemplateCondition {
  OrderConfirmed = 'OrderConfirmed',
  OrderCancelled = 'OrderCancelled',
  RefundRejected = 'RefundRejected',
  Refunded = 'Refunded',
  ReturnApproved = 'ReturnApproved',
  ReturnRejected = 'ReturnRejected',
  ParcelDelivering = 'ParcelDelivering',
  ParcelDelivered = 'ParcelDelivered',
  ReadyToCollect = 'ReadyToCollect',
  ParcelCollected = 'ParcelCollected',
}

export enum ICategory {
  GiftCardIssued = 'GiftCardIssued',
  CreateShoppingCart = 'CreateShoppingCart',
  CreateOrder = 'CreateOrder',
  StoreCreditIssued = 'StoreCreditIssued',
}

export enum PeriodUnit {
  Day = 'Day',
  Hour = 'Hour',
  Minute = 'Minute',
}
